// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1XaqD","quantity":"Item_quantity__1_rNN","plus":"Item_plus__2ulsQ","minus":"Item_minus__1Y_Q8"};